// BeautifulScents Groessen-Umschalter (Auftrag Johannes 16.10.2026)
// Nachbau des ONNI-Linien-Switch: 70 ml und 30 ml sind zwei eigene Produkte,
// keine Varianten. Der Klick tauscht deshalb die ganze Produktseite aus,
// ohne Neuladen: Zielseite holen, <main> per morph ersetzen, URL nachziehen.
import { morph } from '@theme/morph';

const speicher = new Map();
let gewechselt = false;

function laden(url) {
  if (!speicher.has(url)) {
    const anfrage = fetch(url, { credentials: 'same-origin' }).then((antwort) => {
      if (!antwort.ok) throw new Error(`HTTP ${antwort.status}`);
      return antwort.text();
    });
    anfrage.catch(() => speicher.delete(url));
    speicher.set(url, anfrage);
  }
  return speicher.get(url);
}

// Die andere Groesse im Leerlauf vorladen, damit der Wechsel sofort wirkt.
function vorladen(wurzel) {
  wurzel.querySelectorAll('a[data-groesse]').forEach((link) => {
    if (link instanceof HTMLAnchorElement) laden(link.href).catch(() => {});
  });
}

async function wechseln(url) {
  const html = await laden(url);
  const neu = new DOMParser().parseFromString(html, 'text/html');
  neu.querySelector('overflow-list[defer]')?.removeAttribute('defer');

  const main = document.querySelector('main');
  const neuesMain = neu.querySelector('main');
  if (!main || !neuesMain || !neuesMain.querySelector('bs-groessen-switch')) throw new Error('kein main');

  const scrollY = window.scrollY;
  morph(main, neuesMain);

  // Der Preis im Kaufknopf wird nicht im Liquid gerendert, sondern von
  // <bs-produktseite> in connectedCallback gesetzt. morph tauscht nur Inhalte
  // aus, das Element bleibt verbunden und der Preis bliebe vom alten Produkt
  // stehen bzw. faellt weg. Deshalb die Section einmal frisch einhaengen:
  // der Klon wird beim Einfuegen neu aufgebaut und setzt Preis und Knopftext.
  const sektion = main.querySelector('bs-produktseite');
  if (sektion) sektion.replaceWith(sektion.cloneNode(true));
  document.dispatchEvent(new CustomEvent('bs:groesse-gewechselt', { detail: { section: main, url } }));
  document.title = neu.title;
  history.pushState({ bsGroessenSwitch: true }, '', url);
  gewechselt = true;
  window.scrollTo({ top: scrollY, left: window.scrollX, behavior: 'instant' });
}

class BsGroessenSwitch extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#klick);
    (window.requestIdleCallback || ((fn) => setTimeout(fn, 1500)))(() => vorladen(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#klick);
  }

  #klick = (event) => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;
    // Mittelklick, neuer Tab und Tastenkombinationen bleiben normale Links.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (link.classList.contains('is-on') || this.getAttribute('aria-busy') === 'true') return;

    this.setAttribute('aria-busy', 'true');
    wechseln(link.href)
      .catch(() => {
        // Geht etwas schief, ganz normal zur Zielseite.
        window.location.href = link.href;
      })
      .finally(() => {
        document.querySelectorAll('bs-groessen-switch[aria-busy]').forEach((el) => el.removeAttribute('aria-busy'));
        document.querySelectorAll('bs-groessen-switch').forEach(vorladen);
      });
  };
}

if (!customElements.get('bs-groessen-switch')) customElements.define('bs-groessen-switch', BsGroessenSwitch);

// Zurueck-Taste nach einem Wechsel: sauber neu laden statt halb getauschter Seite.
window.addEventListener('popstate', () => {
  if (gewechselt) window.location.reload();
});
